/*
  This module contains type definitions for the `oversight` API.
  These types represent the data structures that are returned or accepted by the `oversight` API,
  providing a clear contract for the shape of data we expect to receive or send.
*/

import type { PointType, PolygonType } from "models/FlightNetwork/MapEntity"


/*
  ******************
  Flight Network
  ******************
*/

export type OversightFlightNetwork = {
  name: string,
  version: number,
  center_point: OversightPoint,
}

export enum FlightNetworkStatus {
  draft = 'draft',
  ready = 'ready',
}

type OversightPoint = {
  name: string,
  type: PointType,
  uuid: string,
  point: [number, number],
  letter?: string | null,
  is_reviewed: boolean,
  is_deleted: boolean,
}

type OversightPolygon = {
  name: string,
  type: PolygonType,
  uuid: string,
  polygon: number[][],
  buffer_m: number,
  is_reviewed: boolean,
  is_deleted: boolean,
}

export type OversightEntity = OversightPoint | OversightPolygon

export type OversightPointPayload = {
  name: string,
  type: string,
  uuid: string,
  point: [number, number],
  letter?: string | null,
  is_reviewed: boolean | null,
  is_deleted: boolean,
}

export type OversightPolygonPayload = {
  name: string,
  type: string,
  uuid: string,
  polygon: number[][],
  buffer_m: number | null,
  is_reviewed: boolean | null,
  is_deleted: boolean,
}

export type Lock = {
  email?: string,
  uuid?: string,
  locked_at?: string,
}

export type FlightNetworkValidationError = {
  description: string,
  entity_uuid: string | null,
}

export type GetGeocodedAddressPayload = {
  lat: number,
  long: number,
}

export type OversightReverseGeocode = {
  formatted_address: string | null,
  lat: number | null,
  long: number | null,
  location_type: string | null,
}

export type OversightGoogleMapsApiKey = {
  api_key: string
}